module.exports = __webpack_public_path__ + "img/36.bfec092b.jpg";